import type { ArtifactCanvasConfig } from '@yeshuman/sdk'
import type { MyApplication } from '../../hooks/use-my-applications'
import { ApplicationStatusCanvas } from './application-status-canvas'

type OpenApplicationStatusCanvasArgs = {
  application: MyApplication
  openCanvas: (config: ArtifactCanvasConfig) => void
  closeCanvas: () => void
  /** Called before in-canvas navigation so the list can skip clearing `?application=`. */
  onBeforeNavigateAway?: () => void
  onWithdrawn?: () => void
}

export function openApplicationStatusCanvas({
  application,
  openCanvas,
  closeCanvas,
  onBeforeNavigateAway,
  onWithdrawn,
}: OpenApplicationStatusCanvasArgs) {
  const org = application.organisation_name?.trim()
  openCanvas({
    preventAutoFocus: true,
    // Company sits in chrome with the job title (not a muted body line).
    title: org ? (
      <span className="min-w-0">
        <span className="block truncate">{application.opportunity_title}</span>
        <span className="block truncate text-sm font-normal text-muted-foreground">{org}</span>
      </span>
    ) : (
      application.opportunity_title
    ),
    content: (
      <ApplicationStatusCanvas
        key={application.id}
        application={application}
        onClose={closeCanvas}
        onBeforeNavigateAway={onBeforeNavigateAway}
        onWithdrawn={onWithdrawn}
      />
    ),
  })
}
